
import * as React from "react";
import { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
const SlideImage = ({img}) => {
    const [image, setImage] = useState([]);
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    const slider1 = useRef(null);
    const slider2 = useRef(null);

  useEffect(() => {
    setImage(img);
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, [image]);

  return (
    <div className="slideImages">
      <Slider className="slideFor" asNavFor={nav2} ref={slider1}
            prevArrow={
            <div>
            <img className="img-fluid" src="/images/ic_prev.png" />
            </div>}
            nextArrow={
            <div>
                <img className="img-fluid" src="/images/ic_next.png" />
            </div>
            } 
      >
         {
            image && image.map(item=>{
                return(
                    <div className="item">
                        <img className="img-fluid" src={item.photo} alt="" />
                    </div>
                )
            })}
                
      </Slider>

      <Slider
      className="slideNav"
        asNavFor={nav1}
        ref={slider2}
        slidesToShow={6}
        swipeToSlide={true}
        focusOnSelect={true}
        arrows={false}
      >
        {
            image && image.map(item=>{
                return(
                    <div className="item">
                        <img className="img-fluid" src={item.photo} alt="" />
                    </div>
                )
            })
            }
      </Slider>
    </div>
  );
};

export default SlideImage;
